// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ion-padding: 12px;
}

p {
  margin: 0;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  width: 100% !important;
}
swiper-slide > ion-col {
  overflow: auto;
  top: 0;
  bottom: 0;
  position: absolute;
}

ion-slide {
  width: 100% !important;
  padding: 10px;
}
ion-slide > ion-col {
  overflow: auto;
  top: 0;
  bottom: 0;
  position: absolute;
  padding: 20px;
  text-align: left;
}
ion-slide:last-of-type {
  background: url('menu_background_mobile.png') no-repeat left top/120% !important;
}

ion-item {
  --min-height: 45px;
  border-radius: 7px;
  border: 1px solid #e5e5e5;
}

.phone-item {
  border: none;
}
.phone-item ion-input:first-child {
  margin-right: 10px;
}
.phone-item ion-input {
  margin-bottom: 5px;
  border-bottom: 1px solid var(--ion-color-dark);
}

ion-card {
  text-align: initial;
  box-shadow: none;
  --color: var(--ion-color-black);
  --preorder-type-chip-border-color: var(--ion-color-primary);
  overflow: auto;
  word-break: break-word;
  background: transparent;
}
ion-card ion-card-content {
  border-top: 0.5px solid #e2dcd5;
  padding: 0px;
  line-break: auto !important;
}
ion-card ion-card-content:first-of-type {
  border: none;
}
ion-card .padding-card {
  padding: 0px;
}
ion-card:nth-child(2) {
  margin-top: 30px;
}

ion-card-header {
  color: var(--ion-color-black);
  padding: 0;
  margin-bottom: 15px;
}
ion-card-header ion-button {
  --background: transparent;
  --color: #54504c;
  text-transform: none;
}

.border-top-light-blue {
  border-top: 0.5px solid #e2dcd5;
}
.border-top-light-blue h3 {
  margin-top: 10px;
  place-self: center;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
}

ion-card-title {
  font-size: 26px;
  color: var(--ion-color-secondary);
  font-family: var(--font-tusker), sans-serif;
  text-transform: uppercase;
  margin-right: 8px;
}

ion-chip {
  background: var(--ion-color-primary);
  padding: 2px 4px;
  border-radius: 28px;
}
ion-chip ion-label {
  color: #fff;
  background-color: var(--ion-color-primary);
}

.card-content-md {
  font-weight: unset;
}

.adds-price {
  padding-left: 5px;
  color: var(--ion-color-medium);
}

.order-at-header {
  text-align: left;
  margin: 10px;
  margin-left: 0px;
  font-size: 20px;
  line-height: 24px;
  text-transform: uppercase;
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-primary);
}

ion-label {
  text-align: left;
  background: white;
  padding: 1px 5px;
}

ion-footer {
  box-shadow: none !important;
  --box-shadow: none !important;
}
ion-footer ion-button {
  padding: 0px 10px;
  font-family: AppFont, san-serif;
}

.padding {
  padding: 25px;
}

.icon-edit {
  height: 26px;
  width: 26px;
  margin-left: 5px;
}

.privacy {
  font-family: OpenSans, sans-serif;
  font-size: 11px;
  color: var(--ion-color-black);
}

.phoneCountry {
  max-width: 15%;
}
@media (min-width: 991px) {
  .phoneCountry {
    max-width: 10%;
  }
}

ion-note {
  font-size: 12px;
}

.stacked {
  position: relative;
  top: 7px;
  left: 10px;
  z-index: 2;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-item {
  --border-radius: 5px;
  --border-width: 0;
  margin-bottom: 0;
  color: #313131;
}

.article-row {
  margin-bottom: 12px;
}
.article-row:last-child {
  margin-bottom: 0;
}

.article_name {
  color: var(--ion-color-primary);
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  line-height: 19.2px;
}

.article_name_total {
  color: #646464;
  font-family: AppFont, sans-serif !important;
}

.article_name_total_right {
  text-align: right;
}

.total_block {
  width: 100%;
  padding: 0px 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price {
  text-align: end;
}

.option-name .info {
  font-family: AppFont600;
  font-size: 12px;
  color: #313131;
}

.separator {
  background: url('border-line.svg') center/100% 100% no-repeat;
  height: 2.2px;
  margin: 7px 0;
}

.tip-row {
  margin-bottom: 7px;
}

.tip {
  text-align: end;
  font-family: AppFontBold;
  font-size: 12px;
  color: var(--ion-color-primary);
}

.left_col {
  font-family: AppFont600;
}

.right_col-wraper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.right_col-wraper .right_col {
  font-family: AppFontBold;
  color: var(--ion-color-primary);
  text-align: right;
}

.terms {
  text-align: center;
}
.terms a {
  color: var(--ion-color-tertiary);
}

.not_bold {
  font-family: AppFont, sans-serif !important;
}

.text-align-right {
  text-align: right;
}

.margin-top {
  margin-top: 10px;
}

.privacy span {
  color: var(--ion-color-subtitle);
  font-size: 12px;
  font-family: AppFontBold;
  line-height: 15px;
}
.privacy .link {
  text-decoration: underline;
  color: var(--ion-color-tertiary);
  position: relative;
  z-index: 100;
}

.custom_phone .item_input,
.custom_phone .item_select {
  --padding-start: 8px !important;
}
.custom_phone .item_select {
  --ripple-color: transparent;
  --background-hover: none;
  border: none !important;
  --border-width: 0px !important;
  --highlight-background: none;
}
.custom_phone .item_select ion-img {
  height: 16px;
  width: 24px;
}

.transparent_back ion-label {
  background: transparent;
  margin-top: 7.5px;
}

ion-intl-tel-input ion-input {
  font-size: 12px !important;
}

ion-select {
  width: 100%;
  background: transparent;
  text-align: left;
}

.title {
  font-family: var(--font-tusker);
  font-size: 26px;
  color: var(--ion-color-secondary);
}

.align-checkbox {
  align-items: start;
}

.background-footer {
  background: #fff url('footer_checkout_background.svg') no-repeat top/cover;
}

.options-col {
  margin-top: -10px;
}

.privacy-second {
  margin-inline: 16px;
  font-family: AppFont600;
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkout-modal/checkout-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;AADF;;AAIA;EACE,SAAA;AADF;;AAIA;EACE,sBAAA;EACA,uBAAA;AADF;;AAIA;EACE,sBAAA;AADF;AAGE;EACE,cAAA;EACA,MAAA;EACA,SAAA;EACA,kBAAA;AADJ;;AAMA;EACE,sBAAA;EACA,aAAA;AAHF;AAIE;EACE,cAAA;EACA,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAFJ;AAKE;EACE,gFAAA;AAHJ;;AAMA;EAEE,kBAAA;EACA,kBAAA;EACA,yBAAA;AAJF;;AAMA;EACE,YAAA;AAHF;AAIE;EACE,kBAAA;AAFJ;AAIE;EACE,kBAAA;EACA,8CAAA;AAFJ;;AAMA;EACE,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,2DAAA;EACA,cAAA;EACA,sBAAA;EAEA,uBAAA;AAJF;AAME;EACE,+BAAA;EACA,YAAA;EACA,2BAAA;AAJJ;AAKI;EACE,YAAA;AAHN;AAOE;EACE,YAAA;AALJ;AAQE;EACE,gBAAA;AANJ;;AAUA;EACE,6BAAA;EACA,UAAA;EACA,mBAAA;AAPF;AAQE;EACE,yBAAA;EACA,gBAAA;EACA,oBAAA;AANJ;;AAUA;EACE,+BAAA;AAPF;AAQE;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;AANJ;;AAUA;EACE,eAAA;EACA,iCAAA;EACA,2CAAA;EACA,yBAAA;EACA,iBAAA;AAPF;;AAUA;EACE,oCAAA;EACA,gBAAA;EACA,mBAAA;AAPF;AAQE;EACE,WAAA;EACA,0CAAA;AANJ;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,iBAAA;EACA,8BAAA;AAPF;;AASA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,oCAAA;EACA,+BAAA;AANF;;AAQA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AALF;;AAOA;EACE,2BAAA;EACA,6BAAA;AAJF;AAKE;EACE,iBAAA;EACA,+BAAA;AAHJ;;AAQA;EACE,aAAA;AALF;;AAOA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AAJF;;AAMA;EACE,iCAAA;EACA,eAAA;EACA,6BAAA;AAHF;;AAKA;EACE,cAAA;AAFF;AC3KE;ED4KF;IAGI,cAAA;EAAF;AACF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AAAF;;AAGA;EACE,eAAA;EACA,mBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;AACE;EACE,gBAAA;AACJ;;AAGA;EACE,+BAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;AAAF;;AAEA;EACE,cAAA;EACA,2CAAA;AACF;;AACA;EACE,iBAAA;AAEF;;AAAA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAGF;;AADA;EACE,eAAA;AAIF;;AAAE;EACE,uBAAA;EACA,eAAA;EACA,cAAA;AAGJ;;AACA;EACE,6DAAA;EACA,aAAA;EACA,aAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,eAAA;EACA,wBAAA;EACA,eAAA;EACA,+BAAA;AAEF;;AASA;EACE,uBAAA;AANF;;AASA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AANF;AAQE;EACE,wBAAA;EACA,+BAAA;EACA,iBAAA;AANJ;;AAUA;EACE,kBAAA;AAPF;AASE;EACE,gCAAA;AAPJ;;AAWA;EACE,2CAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAUA;EACE,gBAAA;AAPF;;AAUE;EACE,gCAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;AAPJ;AASE;EACE,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;AAPJ;;AAYE;;EAEE,+BAAA;AATJ;AAWE;EACE,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,8BAAA;EACA,4BAAA;AATJ;AAWI;EACE,YAAA;EACA,WAAA;AATN;;AAeE;EACE,uBAAA;EACA,iBAAA;AAZJ;;AAiBE;EACE,0BAAA;AAdJ;;AAkBA;EACE,WAAA;EACA,uBAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,+BAAA;EACA,eAAA;EACA,iCAAA;AAfF;;AAkBA;EACE,kBAAA;AAfF;;AAkBA;EACE,0EAAA;AAfF;;AAkBA;EACE,iBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,uBAAA;AAfF","sourcesContent":["@import \"../../../theme/mixins\";\n\n:root {\n  --ion-padding: 12px;\n}\n\np {\n  margin: 0;\n}\n\nswiper-container {\n  width: 100% !important;\n  height: 100% !important;\n}\n\nswiper-slide {\n  width: 100% !important;\n\n  > ion-col {\n    overflow: auto;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n  }\n}\n\n\nion-slide {\n  width: 100% !important;\n  padding: 10px;\n  > ion-col {\n    overflow: auto;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n    padding: 20px;\n    text-align: left;\n  }\n\n  &:last-of-type {\n    background: url('../../../assets/tabilo/menu_background_mobile.png')  no-repeat left top / 120% !important;\n  }\n}\nion-item {\n  // min-height: 45px;\n  --min-height: 45px;\n  border-radius: 7px;\n  border: 1px solid #e5e5e5;\n}\n.phone-item {\n  border: none;\n  ion-input:first-child {\n    margin-right: 10px;\n  }\n  ion-input {\n    margin-bottom: 5px;\n    border-bottom: 1px solid var(--ion-color-dark);\n  }\n}\n\nion-card {\n  text-align: initial;\n  box-shadow: none;\n  --color: var(--ion-color-black);\n  --preorder-type-chip-border-color: var(--ion-color-primary);\n  overflow: auto;\n  word-break: break-word;\n\n  background: transparent;\n\n  ion-card-content {\n    border-top: 0.5px solid #e2dcd5;\n    padding: 0px;\n    line-break: auto !important;\n    &:first-of-type {\n      border: none;\n    }\n\n  }\n  .padding-card {\n    padding: 0px;\n  }\n\n  &:nth-child(2) {\n    margin-top: 30px;\n  }\n}\n\nion-card-header {\n  color: var(--ion-color-black);\n  padding: 0;\n  margin-bottom: 15px;\n  ion-button {\n    --background: transparent;\n    --color: #54504c;\n    text-transform: none;\n  }\n}\n\n.border-top-light-blue {\n  border-top: 0.5px solid #e2dcd5;\n  h3 {\n    margin-top: 10px;\n    place-self: center;\n    font-size: 16px;\n    font-family: AppFontBold, sans-serif;\n  }\n}\n\nion-card-title {\n  font-size: 26px;\n  color: var(--ion-color-secondary);\n  font-family: var(--font-tusker), sans-serif;\n  text-transform: uppercase;\n  margin-right: 8px;\n}\n\nion-chip {\n  background: var(--ion-color-primary);\n  padding: 2px 4px;\n  border-radius: 28px;\n  ion-label {\n    color: #fff;\n    background-color: var(--ion-color-primary);\n  }\n}\n\n.card-content-md {\n  font-weight: unset;\n}\n\n.adds-price {\n  padding-left: 5px;\n  color: var(--ion-color-medium);\n}\n.order-at-header {\n  text-align: left;\n  margin: 10px;\n  margin-left: 0px;\n  font-size: 20px;\n  line-height: 24px;\n  text-transform: uppercase;\n  font-family: AppFontBold, sans-serif;\n  color: var(--ion-color-primary);\n}\nion-label {\n  text-align: left;\n  background: white;\n  padding: 1px 5px;\n}\nion-footer {\n  box-shadow: none !important;\n  --box-shadow: none !important;\n  ion-button {\n    padding: 0px 10px;\n    font-family: AppFont, san-serif;\n    // --background: transparent url('../../../assets/tabilo/button_background_orange.png') no-repeat center center / 100% 100%;\n  }\n}\n\n.padding {\n  padding: 25px;\n}\n.icon-edit {\n  height: 26px;\n  width: 26px;\n  margin-left: 5px;\n}\n.privacy {\n  font-family: OpenSans, sans-serif;\n  font-size: 11px;\n  color: var(--ion-color-black);\n}\n.phoneCountry {\n  max-width: 15%;\n  @include desktop {\n    max-width: 10%;\n  }\n}\n\nion-note {\n  font-size: 12px;\n}\n\n.stacked {\n  position: relative;\n  top: 7px;\n  left: 10px;\n  z-index: 2;\n}\n\nion-note {\n  font-size: 12px;\n  padding-right: 10px;\n}\n\nion-item {\n  --border-radius: 5px;\n  --border-width: 0;\n  margin-bottom: 0;\n  color: #313131;\n}\n\n.article-row {\n  margin-bottom: 12px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.article_name {\n  color: var(--ion-color-primary);\n  font-family: AppFontBold, sans-serif;\n  font-size: 14px;\n  line-height: 19.2px;\n}\n.article_name_total {\n  color: #646464;\n  font-family: AppFont, sans-serif !important;\n}\n.article_name_total_right {\n  text-align: right;\n}\n.total_block {\n  width: 100%;\n  padding: 0px 5px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.price {\n  text-align: end;\n}\n\n.option-name {\n  .info {\n    font-family: AppFont600;\n    font-size: 12px;\n    color: #313131;\n  }\n}\n\n.separator {\n  background: url(\"../../../assets/tabilo/border-line.svg\") center /100% 100% no-repeat;\n  height: 2.2px;\n  margin: 7px 0;\n}\n\n.tip-row {\n  margin-bottom: 7px;\n}\n\n.tip {\n  text-align: end;\n  font-family: AppFontBold;\n  font-size: 12px;\n  color: var(--ion-color-primary);\n}\n\n// .email {\n//   word-break: break-all;\n//   display: -webkit-box;\n//   overflow: hidden;\n//   text-overflow: ellipsis;\n//   -webkit-line-clamp: 1;\n// }\n\n.left_col {\n  font-family: AppFont600;\n}\n\n.right_col-wraper {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  .right_col {\n    font-family: AppFontBold;\n    color: var(--ion-color-primary);\n    text-align: right;\n  }\n}\n\n.terms {\n  text-align: center;\n\n  a {\n    color: var(--ion-color-tertiary);\n  }\n}\n\n.not_bold {\n  font-family: AppFont, sans-serif !important;\n}\n\n.text-align-right {\n  text-align: right;\n}\n.margin-top {\n  margin-top: 10px;\n}\n.privacy {\n  span {\n    color: var(--ion-color-subtitle);\n    font-size: 12px;\n    font-family: AppFontBold;\n    line-height: 15px;\n  }\n  .link {\n    text-decoration: underline;\n    color: var(--ion-color-tertiary);\n    position: relative;\n    z-index: 100;\n  }\n}\n\n.custom_phone {\n  .item_input,\n  .item_select {\n    --padding-start: 8px !important;\n  }\n  .item_select {\n    --ripple-color: transparent;\n    --background-hover: none;\n    border: none !important;\n    --border-width: 0px !important;\n    --highlight-background: none;\n\n    ion-img {\n      height: 16px;\n      width: 24px;\n    }\n  }\n}\n\n.transparent_back {\n  ion-label {\n    background: transparent;\n    margin-top: 7.5px;\n  }\n}\n\nion-intl-tel-input {\n  ion-input {\n    font-size: 12px !important;\n  }\n}\n\nion-select {\n  width: 100%;\n  background: transparent;\n  text-align: left;\n}\n\n.title {\n  font-family: var(--font-tusker);\n  font-size: 26px;\n  color: var(--ion-color-secondary);\n}\n\n.align-checkbox {\n  align-items: start;\n}\n\n.background-footer {\n  background: #fff url(../../../assets/tabilo/footer_checkout_background.svg) no-repeat top/ cover;\n}\n\n.options-col {\n  margin-top: -10px;\n}\n\n.privacy-second {\n  margin-inline: 16px ;\n  font-family: AppFont600;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
